/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const MobileDevice = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M18 1C19.1046 1 20 1.89543 20 3V21C20 22.1046 19.1046 23 18 23H6C4.89543 23 4 22.1046 4 21V3C4 1.89543 4.89543 1 6 1H18ZM18 2.5H6C5.72386 2.5 5.5 2.72386 5.5 3V21C5.5 21.2761 5.72386 21.5 6 21.5H18C18.2761 21.5 18.5 21.2761 18.5 21V3C18.5 2.72386 18.2761 2.5 18 2.5ZM15 18.5V20H9V18.5H15ZM13 4V5.5H11V4H13Z"
                        fill={color}
                    />
                </svg>
        );
    };
